import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";

async function getAllBillingMethodsSelector(campaign_id) {
    try {
        const token = getToken();
        const response = await axiosInstance.get('/api/billing-methods/selector?campaign_id=' + campaign_id, {
            headers: {
                'Authorization': token
            }
        });

        return response?.data;
    } catch (error) {
        console.log(error);
        throw error; // Re-throw the error for further handling if needed
    }
}

export default getAllBillingMethodsSelector;
